/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Privacy_Accept_AfterInputs */

const es_footer_privacy_accept_after = /** @type {(inputs: Footer_Privacy_Accept_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` para recibir la newsletter de Zarpar.`)
};

const gl_footer_privacy_accept_after = /** @type {(inputs: Footer_Privacy_Accept_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` para recibir a newsletter de Zarpar.`)
};

const en_footer_privacy_accept_after = /** @type {(inputs: Footer_Privacy_Accept_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` to receive the Zarpar newsletter.`)
};

/**
* | output |
* | --- |
* | "to receive the Zarpar newsletter." |
*
* @param {Footer_Privacy_Accept_AfterInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_privacy_accept_after = /** @type {((inputs?: Footer_Privacy_Accept_AfterInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Privacy_Accept_AfterInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_privacy_accept_after(inputs)
	if (locale === "en") return en_footer_privacy_accept_after(inputs)
	return es_footer_privacy_accept_after(inputs)
});